import React, {Component} from 'react';
import axios from 'axios';
import OwlCarousel from 'react-owl-carousel';
import cookie from 'react-cookies';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import Navigation from './Navigation';
import Header from './Header';
import Footer from './Footer';
import Pagination from "react-js-pagination";
import ReactPlayer from 'react-player'
import {Redirect} from 'react-router';
import Select from 'react-select';

import '../App.css';

import Chinese from '../translations/cn';
import English from '../translations/en';
import Japanese from '../translations/jp';
import Korean from '../translations/ko';
import German from '../translations/ge';
import French from '../translations/fr';
import Spanish from '../translations/sp';
import Italian from '../translations/it';
import Russian from '../translations/ru';
import Portuguese from '../translations/po';
import Hindi from '../translations/hi';
import Arabic from '../translations/ar';

export const dictionaryList = {
	English,
	Chinese,
	Japanese,
	Korean,
	German,
	French,
	Spanish,
	Italian,
	Russian,
	Portuguese,
	Hindi,
	Arabic
};

class AssetDescription extends Component{
	constructor(props){
		super(props);

		this.state = {
			assetId: 0,
			assetData: null,
			assetImage: '',
			commentList: [],
			dataLanguage: dictionaryList['English'],
			activePage: 1,
			startNumber: 1,
			endNumber: 15,
			countPerPage: 15,
			currentGameId: 0,
			redirect: null,
			videoView: null,
			ownerId: 0,
			ownerName: '',
			ownerAvatar: 'assets/images/profile-img.png',
			newComment: '',
			replyComment: '',
			viewCommentList: null,
			commentPrice: '',
			selectedCurrency: {value: 1, label: '$'},
			selectedConvertCurrency: {value: 1, label: '$'},
			currencyList: [],
			currentVideoUrlList: [],
			showSortItemPopop: false
		}
		
		this.checkLogin = this.checkLogin.bind(this);
		this.setLanguage = this.setLanguage.bind(this);
		this.setWrapperRef = this.setWrapperRef.bind(this);
		this.handleClickOutside = this.handleClickOutside.bind(this);
		this.getAssetData = this.getAssetData.bind(this);
		this.setPagination = this.setPagination.bind(this);
		this.handlePageChange = this.handlePageChange.bind(this);
	}
	
	componentWillMount(){
		document.addEventListener('mousedown', this.handleClickOutside);
	}

	componentDidMount() {
		document.addEventListener('mousedown', this.handleClickOutside);
		if ( localStorage.getItem('Language') ) {
			this.setState({
				dataLanguage: dictionaryList[localStorage.getItem('Language')]
			});
		} else {
			this.setState({
				dataLanguage: dictionaryList['English']
			});
		}

		if (localStorage.getItem('assetOwnerId')) {
			this.setState({
				ownerId: localStorage.getItem('assetOwnerId'),
				ownerName: localStorage.getItem('assetOwnerName'),
				ownerAvatar: localStorage.getItem('assetOwnerAvatar')
			})
		}

		this.getAssetData();
	}

	setWrapperRef(node) {
		this.wrapperRef = node;
	}

	handleClickOutside(event) {
		if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
			this.setState({
				showSortItemPopop: false
			})
		}
	}

	toggleSortItemPopop() {
		this.setState({
			showSortItemPopop: !this.state.showSortItemPopop
		})
	}

	getAssetData() {
		if (localStorage.getItem('assetId') > 0) {
			var assetId = localStorage.getItem('assetId');
			// localStorage.setItem('assetId', 0);

			this.setState({
				assetId: assetId
			}, function(){
				this.getAssetEnhancementList();
				this.getAssetVideoList();
				this.updateCommentList();
			})

			axios.defaults.withCredentials = true;

			axios.get(window.$backend_url + '/getAssetDetails?assetId=' + assetId)
				.then(response => {
					if ( response.status === 200 && response.data.length ) {
						this.setState({
							assetData: response.data[0]
						})

						this.getCurrencyList();

						if (response.data[0].mainImageUrl) {
							this.setState({
								assetImage: response.data[0].mainImageUrl
							})
						} else {
							this.getAssetImage();
						}

						if (this.state.ownerId == 0) {
							var userId = response.data[0].userId;

							const data = {
								userid: response.data[0].userId
							}

							axios.post(window.$backend_url + '/getUserInfo', data)
								.then(response => {
									if ( response.status === 200 ) {
										 this.setState({
											ownerName: response.data[0].first_name + " " + response.data[0].last_name
										})
									}
								})
								.catch(error => {
								})

							axios.post(window.$backend_url + '/getUserAvatar', data)
								.then(response => {
									if ( response.status === 200 ) {
										 this.setState({
											ownerAvatar: response.data
										})
									}
								})
								.catch(error => {
								})
						}

					}
				})
		}
	}

	getAssetImage() {
		if (localStorage.getItem('characterImage')) {
			this.setState({
				assetImage: localStorage.getItem('assetImage')
			})
		} else {
			const data = {
				userId: this.state.assetData.userId,
				gameId: this.state.assetData.gameId,
				assetId: this.state.assetData.id
			}

			axios.post(window.$backend_url + '/getAssetMainImage', data)
				.then(response => {
					if ( response.status === 200 ) {
						this.setState({
							assetImage: response.data
						})
					}
				})
				.catch(error => {
					this.setState({
						assetImage: 'assets/images/popular-game-main.jpg'
					})
				})
		}
	}

	getAssetEnhancementList() {
		axios.defaults.withCredentials = true;

		axios.get(window.$backend_url + '/getAssetEnhancementList?assetId=' + this.state.assetId)
			.then(response => {
				if ( response.status === 200 ) {
					let temp = response.data.map((enhancement, index) => {
						return (
								<div key={index} className="enhancement-item">{enhancement.enhancementName} +{enhancement.value}</div>
							)
					})

					this.setState({
						enhancementList: response.data,
						enhancementView: temp
					});
				}
			})
	}

	getAssetVideoList() {
		axios.defaults.withCredentials = true;

		axios.get(window.$backend_url + '/getAssetVideos?assetId=' + this.state.assetId)
			.then(response => {
				if ( response.status === 200 ) {
					this.setState({
						currentVideoList: response.data,
						currentVideoUrlList: []
					})
					
					for (var i=0; i<response.data.length; i++) {
						let currentIndex = i;
						let temp = this.state.currentVideoUrlList;

						if (response.data[i].url) {
							temp.push(response.data[i].url);
							this.setState({
								currentVideoUrlList: temp
							})
						} else {
							temp.push('/assets/images/loading-2.gif');
							this.setState({
								currentVideoUrlList: temp
							})

							axios.get(window.$backend_url + '/getVideoFromS3?type=2&video=' + response.data[i].name)
								.then(response => {
									let tempList = this.state.currentVideoUrlList;
									tempList[currentIndex] = response.data;
									this.setState({
										currentVideoUrlList: tempList
									})

									this.makeVideoSlider();
								})
						}
					}

					this.makeVideoSlider();
				}
			})
	}

	makeVideoSlider() {
		this.setState({
			videoView: null
		})

		if (this.state.currentVideoUrlList.length) {
			let videos = this.state.currentVideoUrlList.map((video, index) => {
				if (video === '/assets/images/loading-2.gif') {
					return (<img key={index} src={video} />);
				} else {
					return (<ReactPlayer key={index} url={video} controls />);
				}
			})

			this.setState({
				videoView: videos
			})
		}
	}

	goProfilePage(e) {
		if (e.target.getAttribute('rel')) {
			localStorage.setItem('userId', e.target.getAttribute('rel'));
			this.props.history.push('/profile');
			// this.setState({ redirect: "/profile" });
		}
	}

	goAssetPage(e) {
		if (e.target.getAttribute('rel')) {
			localStorage.setItem('gameId', e.target.getAttribute('rel'));
			// this.setState({ redirect: "/assets" });
			this.props.history.push('/assets');
		}
	}

	setLanguage(lang) {
		this.setState({
			dataLanguage: dictionaryList[lang]
		}, function(){
			this.setPagination(this.state.activePage);
		})
	}

	checkLogin() {
		if (cookie.load('cookieId')) {
			this.setState({
				isLogin: true
			}, function(){
				this.setPagination(this.state.activePage);
			})
		} else {
			this.setState({
				isLogin: false
			}, function(){
				this.setPagination(this.state.activePage);
			})
		}
	}

	goProfilePage(e) {
		if (e.target.getAttribute('rel')) {
			localStorage.setItem('userId', e.target.getAttribute('rel'));
			// this.setState({ redirect: "/profile" });
			this.props.history.push('/profile');
		}
	}

	assetLike(e) {
		this.setAssetLike(1);
	}

	assetDislike(e) {
		this.setAssetLike(0);
	}

	setAssetLike(val) {
		if (cookie.load('cookieId')) {
			if (this.state.assetData.userId != cookie.load('cookieId')) {
				const data = {
					userId: cookie.load('cookieId'),
					assetId: this.state.assetId,
					value: val
				}

				axios.defaults.withCredentials = true;

				axios.post(window.$backend_url + '/setAssetLike', data)
					.then(response => {
						if ( response.status === 200 ) {
							var assetData = this.state.assetData;
							this.setState({
								assetData: null
							})

							if (response.data != "ignore") {
								if (val) {
									assetData.likeCount++;
									if (response.data == "updated" && assetData.dislikeCount > 0){
										assetData.dislikeCount--;
									}
								} else {
									assetData.dislikeCount++;
									if (response.data == "updated" && assetData.likeCount > 0){
											assetData.likeCount--;
										
									}
								}
							}

							this.setState({
								assetData: assetData
							})
						}
					})
					.catch(error => {
						
					})
			}
		} else {
			this.refs.header.toggleSignupPopup();
		}
	}

	commentLike(e) {
		this.setCommentLike(e.target.getAttribute('rel'), 1);
	}

	commentDislike(e) {
		this.setCommentLike(e.target.getAttribute('rel'), 0);
	}

	setCommentLike(commentId, val) {
		if (cookie.load('cookieId')) {
			const data = {
				userId: cookie.load('cookieId'),
				commentId: commentId,
				value: val
			}
			
			var flag = true;
			for (var i=0; i<this.state.commentList.length; i++) {
				if (this.state.commentList[i].id == commentId && this.state.commentList[i].userId == cookie.load('cookieId')) {
					flag = false;
				}
			}

			if (flag) {
				axios.defaults.withCredentials = true;
				axios.post(window.$backend_url + '/setCommentLike', data)
					.then(response => {
						if ( response.status === 200 ) {
							var temp = this.state.commentList;
							
							for (var i=0; i<temp.length; i++) {
								if (temp[i].id == commentId) {
									if (response.data != "ignore") {
										if (val) {
											temp[i].likeCount++;
											if (response.data == "updated" && temp[i].dislikeCount > 0){
												temp[i].dislikeCount--;
											}
										} else {
											temp[i].dislikeCount++;
											if (response.data == "updated" && temp[i].likeCount > 0){
												temp[i].likeCount--;
											}
										}
									}

									break;
								}
							}

							this.setState({
								commentList: temp
							})

							this.updateAssetPrice();
							this.setPagination(this.state.activePage);
						}
					})
					.catch(error => {
						
					})
			}
		} else {
			this.refs.header.toggleSignupPopup();
		}
	}

	changeNewCommentHandler(e) {
		this.setState({
			newComment: e.target.value
		});
	}

	getCurrencyList() {
		axios.defaults.withCredentials = true;
		
		// axios.get(window.$backend_url + '/getCurrencyList?type=1')
		axios.get(window.$backend_url + '/getCurrencyList')
			.then(response => {
				if ( response.status === 200 ) {
					var currencyList = [];
					var temp = {value: 1, label: '$'};
					var rate = 1;

					for (var i=0; i<response.data.length; i++) {
						if (response.data[i].symbol) {
							currencyList.push({ value: response.data[i].id, label: response.data[i].symbol });
						} else {
							currencyList.push({ value: response.data[i].id, label: response.data[i].name });
						}
						if (this.state.assetData) {
							if (response.data[i].id === this.state.assetData.currencyId) {
								temp = { value: response.data[i].id, label: response.data[i].symbol };
								if (!response.data[i].symbol) {
									temp = { value: response.data[i].id, label: response.data[i].name };
								}
								rate = response.data[i].rate;
							}
						}
					}

					var tempData = this.state.assetData;
					tempData.price *= rate;

					this.setState({
						assetData: tempData,
						selectedCurrency: temp,
						selectedConvertCurrency: temp,
						currencyList: currencyList,
						orgCurrencyList: response.data
					});


				}
			})
	}

	changeCurrencyHandler = selectedCurrency => {
		this.setState({ 
			selectedCurrency: selectedCurrency
		});
	}

	changeCommentCurrencyHandler = (commentId, selectedCommentCurrency) => {
		var temp = this.state.commentList;

		for (var i = (this.state.activePage - 1) * this.state.countPerPage; i < this.state.activePage * this.state.countPerPage; i++) {
			if (temp[i].id == commentId) {
				temp[i].currencyId = selectedCommentCurrency.value;
				break;
			}
		}

		this.setState({
			commentList: temp
		}, function(){
			this.setPagination(this.state.activePage);
		})
	}

	changeCommentPrice(e) {

	}

	changeConvertCurrencyHandler = selectedConvertCurrency => {
		const fromCurrency = this.state.orgCurrencyList.filter(
			(currency) =>
			currency.id == this.state.selectedConvertCurrency.value
		);

		this.setState({ 
			selectedConvertCurrency: selectedConvertCurrency
		});

		const toCurrency = this.state.orgCurrencyList.filter(
			(currency) =>
			currency.id == selectedConvertCurrency.value
		);

		if (fromCurrency.length && this.state.assetData.price) {
			var temp = this.state.assetData;
			temp.price = parseFloat((parseFloat(this.state.assetData.price) / parseFloat(fromCurrency[0].rate) * parseFloat(toCurrency[0].rate)).toFixed(2));
			this.setState({
				assetData: temp
			})
		}
	}

	changeCommentPriceHandler(e) {
		const commentPrice = (e.target.validity.valid) ? e.target.value : this.state.commentPrice;
		this.setState({ commentPrice });
	}

	postNewComment(e) {
		var comment = this.state.newComment;
		if (e.target.getAttribute('rel') != "0") {
			comment = this.state.replyComment;
		}

		var price = this.state.commentPrice;

		var filteredOptions = this.state.orgCurrencyList.filter(
			(currency) =>
			currency.id == this.state.selectedCurrency.value
		);

		if (filteredOptions.length) {
			price = price / filteredOptions[0].rate;
		}

		if (comment) {
			const data = {
				releatedId: e.target.getAttribute('rel'),
				userId: cookie.load('cookieId'),
				assetId: this.state.assetId,
				newComment: comment,
				currencyId: this.state.selectedCurrency.value,
				price: parseFloat(price).toFixed(10)
			}

			this.setState({
				newComment: '',
				commentPrice: '',
				replyComment: '',
				price: ''
			})

			axios.defaults.withCredentials = true;

			axios.post(window.$backend_url + '/addNewComment', data)
				.then(response => {
					if ( response.status === 200 ) {
						this.updateCommentList();
					}
				})
				.catch(error => {
					
				})
		}
	}

	reportComment(e) {
		const data = {
			userId: cookie.load('cookieId'),
			commentId: e.target.getAttribute('rel')
		}

		axios.defaults.withCredentials = true;

		axios.post(window.$backend_url + '/reportComment', data)
			.then(response => {
				if ( response.status === 200 ) {
					
				}
			})
			.catch(error => {
				
			})
	}

	updateCommentList() {
		axios.defaults.withCredentials = true;

		axios.get(window.$backend_url + '/getAssetComments?assetId=' + this.state.assetId)
			.then(response => {
				if ( response.status === 200 && response.data.length ) {
					this.setState({
						commentList: response.data
					}, function(){
						this.handlePageChange(1);
						this.updateReleatedCommentList();
						this.updateAssetPrice();
					})
				}
			})
	}

	updateAssetPrice(){
		if (this.state.assetData) {
			var max_count = 9;
			var new_price = this.state.assetData.price;
			var currencyId = 0;
			var creditUserId = this.state.assetData.creditUserId;
			for (var i=0; i < this.state.commentList.length; i++) {
				if (this.state.commentList[i].likeCount - this.state.commentList[i].dislikeCount > max_count) {
					max_count = this.state.commentList[i].likeCount - this.state.commentList[i].dislikeCount;
					currencyId = this.state.commentList[i].currencyId;
					creditUserId = this.state.commentList.userId;

					new_price = this.state.commentList[i].price;
					var filteredOptions = this.state.orgCurrencyList.filter(
						(currency) =>
						currency.id == currencyId
					);

					if (filteredOptions.length) {
						new_price = new_price * filteredOptions[0].rate;
					}
				}
			}

			if (currencyId) {
				var tempCurrency = this.state.selectedConvertCurrency;
				for (var i=0; i < this.state.currencyList.length; i++) {
					if (this.state.currencyList[i].id == currencyId) {
						tempCurrency = { value: this.state.currencyList[i].id, label: this.state.currencyList[i].symbol };
						break;
					}
				}

				this.setState({
					selectedConvertCurrency: tempCurrency
				})

			}

			var temp = this.state.assetData;
			temp.price = new_price;

			if (creditUserId != this.state.assetData.creditUserId) {
				temp.creditUserId = creditUserId;
				this.updateCreditUserId(this.state.assetData.id, this.state.assetData.creditUserId, creditUserId);
			}

			this.setState({
				assetData: temp
			})
		}
	}

	updateCreditUserId(assetId, oldCreditUserId, creditUserId) {
		const data = {
			assetId: assetId,
			oldCreditUserId: oldCreditUserId,
			creditUserId: creditUserId,
			assetName: this.state.assetData.name
		}

		axios.defaults.withCredentials = true;
		axios.post(window.$backend_url + '/updateCreditUserId', data)
			.then(response => {
			})
			.catch(error => {
			})
				
	}

	updateReleatedCommentList() {
		for (var i=0; i<this.state.commentList.length; i++) {
			var currentIndex = i;

			axios.defaults.withCredentials = true;			
			axios.get(window.$backend_url + '/getRelatedComments?commentId=' + this.state.commentList[i].id)
				.then(response => {
					if ( response.status === 200 ) {
						var temp = this.state.commentList;
						temp[currentIndex].relatedComments = response.data;
						this.setState({
							commentList: temp
						})
					}
				})
		}
	}

	handlePageChange(pageNumber) {
		this.setState({
			activePage: pageNumber,
			startNumber: (pageNumber - 1) * this.state.countPerPage + 1,
			endNumber: pageNumber * this.state.countPerPage,
		});

		var showCount = this.state.countPerPage;

		if (pageNumber * this.state.countPerPage > this.state.commentList.length) {
			this.setState({
				endNumber: this.state.commentList.length
			})

			showCount = this.state.commentList.length - (pageNumber - 1) * this.state.countPerPage;
		}

		var count = 0;

		for (var i=(pageNumber - 1) * this.state.countPerPage; i<pageNumber * this.state.countPerPage; i++) {
			if (i >= this.state.commentList.length) {
				break;
			}
			
			let currentIndex = i;
			let currentUserId = this.state.commentList[i].userId;

			axios.defaults.withCredentials = true;

			axios.get(window.$backend_url + '/getRelatedComments?commentId=' + this.state.commentList[i].id)
				.then(response => {
					if ( response.status === 200 ) {
						var temp = this.state.commentList;
						temp[currentIndex].relatedComments = response.data;
						this.setState({
							commentList: temp
						})

						if (this.state.commentList[currentIndex].profile_img == (this.state.commentList[currentIndex].userId + ".png")){
							const userdata = {
								userid: this.state.commentList[currentIndex].userId
							}

							axios.defaults.withCredentials = true;

							axios.post(window.$backend_url + '/getUserAvatar', userdata)
								.then(response => {
									var temp = this.state.commentList;
									var userAvatar = '';
									if ( response.status === 200 ) {
										userAvatar = response.data;
									}

									const filteredOptions = temp.filter(
										(comment) =>
										comment.userId == currentUserId
									);

									var index = 0;

									while (filteredOptions.length && index < temp.length) {
										if (temp[index].id == filteredOptions[0].id) {
											temp[index].profile_img = userAvatar;
											filteredOptions.shift();
										}

										index++;
									}

									this.setState({
										commentList: temp
									})

									count++;
									if (count == showCount) {
										this.setPagination(pageNumber);
									}

								})
								.catch(error => {
									var temp = this.state.commentList;
									temp[currentIndex].profile_img = '';
									this.setState({
										commentList: temp
									})
									count++;
									if (count == showCount) {
										this.setPagination(pageNumber);
									}
								})
						} else {
							count++;

							if (count == showCount) {
								this.setPagination(pageNumber);
							}
						}
					}
				})
				.catch(error => {
				})
		}
	}

	setPagination(currentPage) {
		const customStyle = {
			control: styles => ({ 
				...styles,
				backgroundColor: 'white',
				color: 'black',
				border: 'none',
				borderRadius: '20px 0 0 20px',
				boxShadow: 'none',
				outline: 'none',
				"&:hover": {
					color: 'white',
					outline: 'none',
					boxShadow: 'none'
				},
				"&:focus": {
					color: 'white',
					outline: 'none',
					boxShadow: 'none'
				}
			}),
			option: (styles, { data, isDisabled, isFocused, isSelected }) => {
				return {
					backgroundColor: isFocused ? '#ddd' : 'white',
					color: isFocused ? 'black' : 'gray',
					padding: '10px',
					size: 5,
					cursor: 'pointer',
					"&:hover": {
						border: 'none',
						boxShadow: 'none',
						outline: 'none'
					},
					"&:focus": {
						border: 'none',
						boxShadow: 'none',
						outline: 'none'
					}
				};
			},
			container: (base, state) => ({
				...base,
				border: state.isFocused ? null : null,
				"&:hover": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				},
				"&:focus": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				}
			}),
			singleValue: (provided, state) => ({
				...provided,
				color: "black",
				"&:hover": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				},
				"&:focus": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				}
			})
		}

		let comments = this.state.commentList.map((comment, index) => {
			if (index >= (currentPage - 1) * this.state.countPerPage && index < currentPage * this.state.countPerPage) {
				let userBackStyle = {
					backgroundImage:  "url('" + comment.profile_img + "')"
				};

				const filteredOptions = this.state.orgCurrencyList.filter(
							(currency) =>
							currency.id == comment.currencyId
						);

								
				if (filteredOptions.length && comment.price) {
					if (filteredOptions[0].symbol) {
						comment.commentCurrency = {value: filteredOptions[0].id, label: filteredOptions[0].symbol};
					} else {
						comment.commentCurrency = {value: filteredOptions[0].id, label: filteredOptions[0].name};
					}
					comment.commentPrice = parseFloat((comment.price * filteredOptions[0].rate).toFixed(2));
				}

				let relatedComments = comment.relatedComments.map((relatedComment, index) => {
					return (
							<div key={index} className="relatedComment">
								<span className="text-yellow username" onClick={this.goProfilePage.bind(this)} rel={relatedComment.userId}>{relatedComment.first_name + ' ' + relatedComment.last_name}</span>
								<span>
									{new Intl.DateTimeFormat("en-US", {
												month: "2-digit",
												year: "numeric",
												day: "2-digit",
												hour: "2-digit",
												minute: "2-digit",
												second: "2-digit"
											}).format(new Date(relatedComment.date)).toString().replace(/\//g, "-")}
								</span>
								<p>{relatedComment.comment}</p>
							</div>
						)
				})

				return (
						<div key={index} className="commentItem">
							<div className="commentHeader">
								<div className="row">
									<div className="col-6">
										<p className="commentDate">
											{new Intl.DateTimeFormat("en-US", {
												month: "2-digit",
												year: "numeric",
												day: "2-digit",
												hour: "2-digit",
												minute: "2-digit",
												second: "2-digit"
											}).format(new Date(comment.date)).toString().replace(/\//g, "-")}
										</p>
									</div>
									{ this.state.isLogin ?
										<div className="col-6 text-right">
											<div className="btn_report" onClick={this.reportComment.bind(this)}>
												<img alt="" src="/assets/images/icons/flag-report.png" rel={comment.id} />
												<span rel={comment.id}>{this.state.dataLanguage['report']}</span>
												<span className="text-yellow">#{comment.id}</span>
											</div>
										</div>
									: null }
								</div>
							</div>
							<div className="commentBody">
								<div className="row">
									<div className="col-md-2 userInfo">
										<div className="img_character" style={userBackStyle} onClick={this.goProfilePage.bind(this)} rel={comment.userId}></div>
										<div>
											<p className="text-yellow username" onClick={this.goProfilePage.bind(this)} rel={comment.userId}>{comment.first_name + ' ' + comment.last_name}</p>
											<p>{this.state.dataLanguage['join_date']}: {new Intl.DateTimeFormat("en-US", {
												month: "long",
												year: "numeric"
											}).format(new Date(comment.createDate)).toString().replace(/\//g, "-")}</p>
											<p>{this.state.dataLanguage['asset_networth'] + ": " + comment.count}</p>
										</div>
									</div>
									<div className="col-md-10 commentBodyBorder">
										<p>{comment.comment}</p>
										<div className="row">
											<div className="col-md-10">
												{ comment.commentPrice ?
													<div className="commentPriceWrap">
														<div>
															<p className="text-yellow priceTitle">{this.state.dataLanguage['new_suggested_price']}</p>
															<div className="twoInput">
																<div className="half">
																	<Select styles={customStyle} options={this.state.currencyList} onChange={e => this.changeCommentCurrencyHandler(comment.id, e)} value={comment.commentCurrency} />
																</div>
																<div className="half">
																	<input type="text" pattern="[0-9]*" value={comment.commentPrice} onChange={this.changeCommentPrice.bind(this)} className="form-control" />
																</div>
															</div>
														</div>
														<span className="commentLike"><img onClick={this.commentLike.bind(this)} rel={comment.id} alt="" src="/assets/images/icons/like-2.png" />{comment.likeCount}</span>
														<span className="commentLike"><img onClick={this.commentDislike.bind(this)} rel={comment.id} alt="" src="/assets/images/icons/dislike-2.png" />{comment.dislikeCount}</span>
													</div>
												: null }
											</div>
											<div className="col-md-2">
												<div className="text-right">
													<span className="text-yellow text-reply" onClick={this.replyComment.bind(this)} rel={index}>{this.state.dataLanguage['reply']}...</span>
												</div>
											</div>
										</div>
									</div>
								</div>
								{relatedComments ?
									<div className="row">
										<div className="col-md-2">
										</div>
										<div className="col-md-10">
											{relatedComments}
										</div>
									</div>
								: null }
								{ comment.toggleReply ?
									<div className="row">
										<div className="col-md-2"></div>
										<div className="col-md-10">
											<div className="replyCommentOut">
												<textarea className="replyComment" rows="5" onChange={this.changeReplyCommentHandler.bind(this)} />
												<button className="btn_yellow" onClick={this.postNewComment.bind(this)} rel={comment.id}>{this.state.dataLanguage['post']}</button>
											</div>
										</div>
									</div>
								: null }
							</div>
						</div>
					);
			}
		})

		this.setState({
			viewCommentList: comments
		})
	}

	replyComment(e) {
		var temp = this.state.commentList;
		var value = !temp[e.target.getAttribute('rel')].toggleReply;

		for (var i=0; i<temp.length; i++) {
			temp[i].toggleReply = false;
		}

		temp[e.target.getAttribute('rel')].toggleReply = value;

		this.setState({
			commentList: temp,
			replyComment: '',
		}, function(){
			this.setPagination(this.state.activePage);
		})
	}

	changeReplyCommentHandler(e) {
		this.setState({
			replyComment: e.target.value
		});
	}

	sortComment(e) {
		switch(e.target.getAttribute('rel')){
			case '1':
				this.state.commentList.sort((a, b) => new Date(a.date) - new Date(b.date));
				break;
			case '2':
				this.state.commentList.sort((a, b) => new Date(b.date) - new Date(a.date));
				break;
			case '3':
				this.state.commentList.sort((a, b) => b.relatedComments.length- a.relatedComments.length);
				break;
			case '4':
				this.state.commentList.sort((a, b) => (b.likeCount - b.dislikeCount) - (a.likeCount - a.dislikeCount));
				break;
		}
		
		this.setPagination(this.state.activePage);
		this.toggleSortItemPopop();
	}

	render(){
		const { selectedCurrency } = this.state;
		const { selectedConvertCurrency } = this.state;

		if (this.state.redirect) {
			return <Redirect to={this.state.redirect} />
		}

		let assetBackStyle = {
			 backgroundImage: "url('" + this.state.assetImage + "')"
		};

		let userBackStyle = {
			backgroundImage: "url('" + this.state.ownerAvatar + "')"
		};

		const customStyle = {
			control: styles => ({ 
				...styles,
				backgroundColor: 'white',
				color: 'black',
				border: 'none',
				borderRadius: '20px 0 0 20px',
				boxShadow: 'none',
				outline: 'none',
				"&:hover": {
					color: 'white',
					outline: 'none',
					boxShadow: 'none'
				},
				"&:focus": {
					color: 'white',
					outline: 'none',
					boxShadow: 'none'
				}
			}),
			option: (styles, { data, isDisabled, isFocused, isSelected }) => {
				return {
					backgroundColor: isFocused ? '#ddd' : 'white',
					color: isFocused ? 'black' : 'gray',
					padding: '10px',
					size: 5,
					cursor: 'pointer',
					"&:hover": {
						border: 'none',
						boxShadow: 'none',
						outline: 'none'
					},
					"&:focus": {
						border: 'none',
						boxShadow: 'none',
						outline: 'none'
					}
				};
			},
			container: (base, state) => ({
				...base,
				border: state.isFocused ? null : null,
				"&:hover": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				},
				"&:focus": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				}
			}),
			singleValue: (provided, state) => ({
				...provided,
				color: "black",
				"&:hover": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				},
				"&:focus": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				}
			})
		}

		const customStyle2 = {
			control: styles => ({ 
				...styles,
				backgroundColor: 'white',
				color: 'black',
				border: 'solid 3px #ffd33f',
				borderRadius: '20px',
				boxShadow: 'none',
				outline: 'none',
				"&:hover": {
					color: 'white',
					outline: 'none',
					boxShadow: 'none'
				},
				"&:focus": {
					color: 'white',
					outline: 'none',
					boxShadow: 'none'
				}
			}),
			option: (styles, { data, isDisabled, isFocused, isSelected }) => {
				return {
					backgroundColor: isFocused ? '#ddd' : 'white',
					color: isFocused ? 'black' : 'gray',
					padding: '10px',
					size: 5,
					"&:hover": {
						border: 'none',
						boxShadow: 'none',
						outline: 'none'
					},
					"&:focus": {
						border: 'none',
						boxShadow: 'none',
						outline: 'none'
					}
				};
			},
			container: (base, state) => ({
				...base,
				border: state.isFocused ? null : null,
				"&:hover": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				},
				"&:focus": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				}
			}),
			singleValue: (provided, state) => ({
				...provided,
				color: "black",
				"&:hover": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				},
				"&:focus": {
					border: 'none',
					boxShadow: 'none',
					outline: 'none'
				}
			})
		}

		return(
			<div className="digit asset_description">
				<Header history={this.props.history} ref="header" dataLanguage={this.state.dataLanguage} setLanguage={this.setLanguage.bind(this)} checkLogin={this.checkLogin.bind(this)} />
				<div>
					<section className="banner">
						<div className="container">
							<Navigation active="3" dataLanguage={this.state.dataLanguage} history={this.props.history} header={this.refs.header} />
							
							{ this.state.videoView ?
								<div className="banner-slider video-slider">
									<div className="owl-slider">
										<OwlCarousel id="videoSlider" items={1} className="owl-theme" loop nav margin={1} responsiveClass={true} >
											{ this.state.videoView }
										</OwlCarousel>
									</div>
								</div>
							: null }
							<div className="asset_info">
								<div className="row">
									<div className="col-md-3">
										<div className="back-avatar" style={assetBackStyle}>
										</div>
									</div>
									<div className="col-md-9">
										{ this.state.assetData ?
											<div className="asset_details">
												<div className="row mb-15">
													<div className="col-md-4">
														<div className="profile-img">
															<div className="userAvatar" style={userBackStyle} onClick={this.goProfilePage.bind(this)} rel={this.state.ownerId}></div>
															<p className="userName" onClick={this.goProfilePage.bind(this)} rel={this.state.ownerId}>{this.state.ownerName}</p>
														</div>
														<p className="big-text"><span className="text-yellow">{this.state.dataLanguage['game']}:</span> <span className="button-text" onClick={this.goAssetPage.bind(this)} rel={this.state.assetData.gameId}>{this.state.assetData.game_name}</span></p>
														<p className="big-text"><span className="text-yellow">{this.state.dataLanguage['item_name']}:</span> {this.state.assetData.name}</p>
														<p className="big-text"><span className="text-yellow">{this.state.dataLanguage['rarity']}:</span> {this.state.assetData.rarity_name}</p>
													</div>
													<div className="col-md-8">
														<p className="description"><span className="text-yellow">{this.state.dataLanguage['description']}:</span> {this.state.assetData.description}</p>
													</div>
												</div>
												<div className="row">
													<div className="col-md-6">
														{ this.state.enhancementView ?
															<div className="enhancement-list">
																{ this.state.enhancementView }
															</div>
														: null }
													</div>
													<div className="col-md-6">
														<div className="text-right">
															<div className="profile-likes">
																<span className="btn_like" onClick={this.assetLike.bind(this)}><img alt="" src="/assets/images/icons/like-icon.png" />{this.state.assetData.likeCount}</span>
																<span className="btn_like" onClick={this.assetDislike.bind(this)}><img alt="" src="/assets/images/icons/dislike-icon.png" />{this.state.assetData.dislikeCount}</span>
															</div>
															<div className="asset_price">
																<div className="currencyWrap">
																	<Select styles={customStyle2} options={this.state.currencyList} onChange={this.changeConvertCurrencyHandler} value={selectedConvertCurrency} />
																</div>
																<p>{parseFloat(parseFloat(this.state.assetData.price).toFixed(2))}</p>
															</div>
														</div>
													</div>
												</div>
											</div>
										: null }
									</div>
								</div>
							</div>

							<h3 className="commentTitle text-center">{this.state.dataLanguage['comments']}</h3>
							<div className="text-right btn_sort_wrap">
								<div className="btn_sort" onClick={this.toggleSortItemPopop.bind(this)}>
									<span className="text-yellow">{this.state.dataLanguage['sort_by']}</span>
									<img alt="" src="/assets/images/icons/sort.png" />
								</div>
								{ this.state.showSortItemPopop ?
									<ul ref={this.setWrapperRef} className="sortList">
										<li className="sortItem" onClick={this.sortComment.bind(this)} rel="1">{this.state.dataLanguage['first']}</li>
										<li className="sortItem" onClick={this.sortComment.bind(this)} rel="2">{this.state.dataLanguage['last']}</li>
										<li className="sortItem" onClick={this.sortComment.bind(this)} rel="3">{this.state.dataLanguage['most_replies']}</li>
										<li className="sortItem" onClick={this.sortComment.bind(this)} rel="4">{this.state.dataLanguage['new_pricing_recommendations']}</li>
									</ul>
								: null }
							</div>
							{ this.state.viewCommentList ?
								<div className="commentList">
									{this.state.viewCommentList}
								</div>
							: null }
							{ this.state.isLogin ?
								<div className={ this.state.commentList.length ? 'commentListWrap' : 'active commentListWrap' }>
									<h3 className="text-center">{this.state.dataLanguage['add_comments']}</h3>
									<div className="addComment">
										<textarea className="form-control newComment" rows="5" value={this.state.newComment} onChange={this.changeNewCommentHandler.bind(this)} />
										<div className="newPriceWrap">
											<p className="text-yellow">{this.state.dataLanguage['new_suggested_price']}</p>
											<div className="twoInput">
												<div className="half">
													<Select styles={customStyle} options={this.state.currencyList} onChange={this.changeCurrencyHandler} value={selectedCurrency} />
												</div>
												<div className="half">
													<input type="text" pattern="[0-9]*" value={this.state.commentPrice} onChange={this.changeCommentPriceHandler.bind(this)} className="form-control" />
												</div>
											</div>
										</div>
									</div>
									<div className="text-center">
										<button className="btn_yellow" onClick={this.postNewComment.bind(this)} rel="0">{this.state.dataLanguage['post']}</button>
									</div>
								</div>
							: null }
							{this.state.commentList.length ?
								<div className="paginationContainer">
									<div className="row">
										<div className="col-md-6">
											<p className="paginationText">{this.state.dataLanguage['showing']} {this.state.startNumber}-{this.state.endNumber} {this.state.dataLanguage['of']} {this.state.commentList.length} {this.state.dataLanguage['results']}</p>
										</div>
										<div className="col-md-6 text-right">
											<Pagination
											  activePage={this.state.activePage}
											  itemsCountPerPage={this.state.countPerPage}
											  totalItemsCount={this.state.commentList.length}
											  pageRangeDisplayed={5}
											  itemClass="btnPagination"
											  itemClassFirst="btnControl"
											  itemClassLast="btnControl"
											  itemClassNext="btnControl"
											  itemClassPrev="btnControl"
											  prevPageText="<"
											  nextPageText=">"
											  onChange={this.handlePageChange}
											/>
										</div>
									</div>
								</div>
							: null }
						</div>
					</section>
					
					<div className="main-area">
						<div className="container">
						</div>
					</div>
				</div>
				<Footer dataLanguage={this.state.dataLanguage} header={this.refs.header} />
			</div>
		)
	}
}

export default AssetDescription;


// WEBPACK FOOTER //
// ./src/components/AssetDescription.js